import React from 'react'
import { Col, Row } from 'reactstrap'

const AboutCoreValues = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4'>
            <div className='flex-center'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-'>
                    OUR CORE VALUES
                </div>
            </div>
                <div className='pb-md-5 pb-4'>
                    <center>
                        <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                    </center>
                </div>

            <div className='left-padding5rem right-padding5rem pb-md-4'>
                <Row className=''>
                    <Col md='4' className='pb-md-0 pb-3'>
                        <div className='bg-im ' style={{ backgroundImage:'url("about-us/About-Us-bg-shape1.1.png")', height:'auto', width:'', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat', padding:'5rem 7rem 5rem 7rem'}}>
                        <div className='flex-center pb-2'>
                            <img src='about-us/About-Us-icon1.png' alt='' height='auto' width='70px' className=''  />
                        </div>

                        <div className='flex-center pt-4'>
                            <div className='fs-ss-20 text-montserrat fw-700 lh-1 text-ss-secondary ' style={{ letterSpacing:'-1px'}}>
                                Integrity
                            </div>
                        </div>
                        </div>
                    </Col>
                    <Col md='4' className='pb-md-0 pb-3'>
                        <div className='bg-im ' style={{ backgroundImage:'url("about-us/About-Us-bg-shape1.1.png")', height:'auto', width:'', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat', padding:'5rem 7rem 5rem 7rem'}}>
                        <div className='flex-center pb-2'>
                            <img src='about-us/About-Us-icon2.png' alt='' height='auto' width='70px' className=''  />
                        </div>

                        <div className='flex-center pt-4'>
                            <div className='fs-ss-20 text-montserrat fw-700 lh-1 text-ss-secondary ' style={{ letterSpacing:'-1px'}}>
                                Quality
                            </div>
                        </div>
                        </div>
                    </Col>
                    <Col md='4' className='pb-md-0 pb-3'>
                        <div className='bg-im ' style={{ backgroundImage:'url("about-us/About-Us-bg-shape1.1.png")', height:'auto', width:'', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat', padding:'5rem 7rem 5rem 7rem'}}>
                        <div className='flex-center pb-2'>
                            <img src='about-us/About-Us-icon3.png' alt='' height='auto' width='70px' className=''  />
                        </div>

                        <div className='flex-center pt-4'>
                            <div className='fs-ss-20 text-montserrat fw-700 lh-1 text-ss-secondary ' style={{ letterSpacing:'-1px'}}>
                                Accountability
                            </div>
                        </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default AboutCoreValues